const config = {
  CLIENT_ID: "MAGELLAN-GLOBAL2022",
  URL_CONFIG: "https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/magellan-global2022/config/index.json?v=20210622-1",
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  MUX_ANALYTICS_KEY: "g390j6uqqi612ienbuk94q10h",
  S3_REGION: "ap-southeast-2",
  S3_BUCKET: "events-public-assets",
  COGNITO_REGION: "ap-southeast-2",
  COGNITO_USER_POOL_ID: "ap-southeast-2_10sFH20Db",
  COGNITO_APP_CLIENT_ID: "45d2mk78bn6oi7od2t3q8lcf7t",
  COGNITO_IDENTITY_POOL_ID: "ap-southeast-2:eac99773-197d-464a-9c7b-20f268d9b63b",
  BACKEND_REGION: "ap-southeast-2",
  BACKEND_URL: "https://x6tm1s363a.execute-api.ap-southeast-2.amazonaws.com/magellan",
  BACKEND_API_NAME: "backend-api",
  ZENDESK_API_TOKEN: "42pzgqiuUL6qTOtljOIJWcELj2lJN3qA9ADBL9Ig",
};

export default config;
